"use strict";
// ATTENTION: DO NOT ADD REQUIRED() FLAG TO CLAIM SCHEMA
// Required fields are enforced at the end of claim-schema.ts `const submittedClaimSchema = claimSchema.options({ presence: 'required' });`
// This will ensure that all fields not explicitly marked as optional() are required
Object.defineProperty(exports, "__esModule", { value: true });
exports.detail = void 0;
var claim_domain_1 = require("@hobt/claim-domain");
var utils_1 = require("@hobt/utils");
var Joi = require('joi').extend(require('@joi/date'));
exports.detail = Joi.object({
    additionalSecuritiesHeldByBorrower: Joi.number()
        .integer()
        .min(claim_domain_1.AdditionalSecuritiesHeldByBorrower.ChattelMortgage)
        .max(claim_domain_1.AdditionalSecuritiesHeldByBorrower.Other)
        .optional()
        .allow('')
        .allow(null)
        .allow(NaN)
        .options({ convert: false }),
    calendarDaysDeferredCount: Joi.number()
        .integer()
        .min(0)
        .max(120)
        .optional()
        .allow('')
        .allow(null)
        .options({ convert: false }),
    claimFilingExtensionObtained: Joi.boolean(),
    contested: Joi.boolean(),
    dateApprovedLenderNotifiedToSubmitClaim: Joi.date()
        .less(utils_1.getCurrentDate())
        .optional()
        .allow(''),
    dateLegalActionCompleted: Joi.date()
        .min(Joi.ref('dateLegalActionStarted'))
        .less(utils_1.getCurrentDate())
        .when('typeOfClaim', {
        is: claim_domain_1.TypeOfClaim.WalkAway,
        then: Joi.optional().allow(''),
        otherwise: Joi.required(),
    }),
    dateLegalActionStarted: Joi.date()
        .less(utils_1.getCurrentDate())
        .when('typeOfClaim', {
        is: claim_domain_1.TypeOfClaim.WalkAway,
        then: Joi.optional().allow(''),
        otherwise: Joi.required(),
    }),
    britishColumbiaYukonSaleClosing: Joi.date()
        .less(utils_1.getCurrentDate())
        .optional()
        .allow('')
        .when('typeOfClaim', {
        switch: [
            {
                is: claim_domain_1.TypeOfClaim.TitleTransfer,
                then: Joi.optional(),
            },
            {
                is: claim_domain_1.TypeOfClaim.AssignmentOfMortgage,
                then: Joi.optional(),
            },
        ],
    }),
    dateOfferAccepted: Joi.date()
        .less(utils_1.getCurrentDate())
        .optional()
        .when('typeOfClaim', {
        is: claim_domain_1.TypeOfClaim.DeficiencySale,
        then: Joi.required(),
    }),
    deficiencySaleClosingDate: Joi.date()
        .less(utils_1.getCurrentDate())
        .optional()
        .when('typeOfClaim', {
        is: claim_domain_1.TypeOfClaim.DeficiencySale,
        then: Joi.required(),
    }),
    deficiencySalePrice: Joi.number()
        .min(-9999999999999.99)
        .max(0)
        .precision(2)
        .options({ convert: false })
        .optional()
        .when('typeOfClaim', {
        is: claim_domain_1.TypeOfClaim.DeficiencySale,
        then: Joi.required(),
        otherwise: Joi.optional().allow(null),
    }),
    dueDateOfLastCompleteInstallmentPaid: Joi.date().less(utils_1.getCurrentDate()),
    eviction: Joi.boolean(),
    interestAdjustmentDate: Joi.date().less(utils_1.getCurrentDate()),
    interestAtDefaultRate: Joi.number()
        .min(-999999.9999)
        .max(999999.9999)
        .precision(4)
        .options({ convert: false }),
    legalActionType: Joi.number()
        .integer()
        .options({ convert: false })
        .optional()
        .when('legalSystemType', {
        switch: [
            {
                is: claim_domain_1.LegalSystemType.CommonLaw,
                then: Joi.valid(claim_domain_1.LegalActionType.Foreclosure, claim_domain_1.LegalActionType.PowerofSale, claim_domain_1.LegalActionType.QuitClaim, claim_domain_1.LegalActionType.WalkAway, claim_domain_1.LegalActionType.AssignmentOfMortgage).required(),
            },
            {
                is: claim_domain_1.LegalSystemType.CivilLaw,
                then: Joi.valid(claim_domain_1.LegalActionType.TakingInPaymentByForce, claim_domain_1.LegalActionType.TakingInPaymentVoluntary, claim_domain_1.LegalActionType.SaleByJudicialAuthority, claim_domain_1.LegalActionType.WalkAway, claim_domain_1.LegalActionType.AssignmentOfMortgage).required(),
            },
        ],
    }),
    legalSystemType: Joi.number()
        .integer()
        .min(claim_domain_1.LegalSystemType.CommonLaw)
        .max(claim_domain_1.LegalSystemType.Other)
        .options({ convert: false }),
    mobileHomeOnLeasedLand: Joi.boolean()
        .optional()
        .allow(''),
    mortgageType: Joi.number()
        .integer()
        .min(claim_domain_1.MortgageType.Standard)
        .max(claim_domain_1.MortgageType.Collateral)
        .options({ convert: false }),
    otherLegalActionType: Joi.string()
        .min(0)
        .max(60)
        .when('legalSystemType', {
        is: claim_domain_1.LegalSystemType.Other,
        then: Joi.required(),
        otherwise: Joi.optional().allow(''),
    }),
    propertyOccupancyStatus: Joi.number()
        .integer()
        .min(claim_domain_1.PropertyOccupancyStatus.Vacant)
        .max(claim_domain_1.PropertyOccupancyStatus.OccupiedByARelativeOfTheBorrower)
        .options({ convert: false })
        .optional()
        .when('typeOfClaim', {
        is: Joi.valid(claim_domain_1.TypeOfClaim.TitleTransfer, claim_domain_1.TypeOfClaim.AssignmentOfMortgage),
        then: Joi.required(),
    }),
    propertySoldBy: Joi.number()
        .integer()
        .min(claim_domain_1.PropertySoldBy.ByApprovedLender)
        .max(claim_domain_1.PropertySoldBy.ByBorrower)
        .options({ convert: false })
        .optional()
        .when('typeOfClaim', {
        is: claim_domain_1.TypeOfClaim.DeficiencySale,
        then: Joi.required(),
    }),
    propertyTransferredBy: Joi.number()
        .integer()
        .options({ convert: false })
        .optional()
        .when('typeOfClaim', {
        switch: [
            {
                is: claim_domain_1.TypeOfClaim.TitleTransfer,
                then: Joi.valid(claim_domain_1.PropertyTransferredBy.ByApprovedLender, claim_domain_1.PropertyTransferredBy.ByBorrower).required(),
            },
            {
                is: claim_domain_1.TypeOfClaim.AssignmentOfMortgage,
                then: Joi.valid(claim_domain_1.PropertyTransferredBy.WithLegalAction, claim_domain_1.PropertyTransferredBy.WithoutLegalAction).required(),
            },
        ],
    }),
    propertyVacancyDate: Joi.date()
        .optional()
        .when('propertyOccupancyStatus', {
        is: claim_domain_1.PropertyOccupancyStatus.Vacant,
        then: Joi.required(),
    }),
    propertyVacatedBy: Joi.number()
        .integer()
        .min(claim_domain_1.PropertyVacatedBy.Borrower)
        .max(claim_domain_1.PropertyVacatedBy.RelativeOfBorrower)
        .options({ convert: false })
        .optional()
        .when('propertyOccupancyStatus', {
        is: claim_domain_1.PropertyOccupancyStatus.Vacant,
        then: Joi.required(),
        otherwise: Joi.allow(NaN),
    }),
    realEstateCommissionPaid: Joi.number()
        .min(-9999999999999.99)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false })
        .optional()
        .when('typeOfClaim', {
        is: claim_domain_1.TypeOfClaim.DeficiencySale,
        then: Joi.required(),
        otherwise: Joi.optional().allow(null),
    }),
    representativeToObtainKey: Joi.object({
        fullName: Joi.string()
            .min(1)
            .max(40)
            .optional()
            .when('typeOfClaim', {
            is: Joi.valid(claim_domain_1.TypeOfClaim.TitleTransfer, claim_domain_1.TypeOfClaim.AssignmentOfMortgage),
            then: Joi.required(),
        }),
        phoneNumber: Joi.string()
            .min(10)
            .max(10)
            .optional()
            .when('typeOfClaim', {
            is: Joi.valid(claim_domain_1.TypeOfClaim.TitleTransfer, claim_domain_1.TypeOfClaim.AssignmentOfMortgage),
            then: Joi.required(),
        }),
    }).optional(),
    taxAccountBalanceAmount: Joi.number()
        .min(-9999999999999.99)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false }),
    taxAccountBalanceType: Joi.number()
        .integer()
        .min(claim_domain_1.TaxAccountBalanceType.Deficit)
        .max(claim_domain_1.TaxAccountBalanceType.Surplus)
        .options({ convert: false }),
    typeOfClaim: Joi.number()
        .integer()
        .min(claim_domain_1.TypeOfClaim.TitleTransfer)
        .max(claim_domain_1.TypeOfClaim.WalkAway)
        .options({ convert: false }),
    unpaidPrincipalBalanceAmount: Joi.number()
        .min(-9999999999999.99)
        .max(9999999999999.99)
        .precision(2)
        .options({ convert: false }),
    warrantyType: Joi.number()
        .integer()
        .min(claim_domain_1.WarrantyType.ApprovedLendersCorporateWarranty)
        .max(claim_domain_1.WarrantyType.TitleInsurance)
        .options({ convert: false }),
});
exports.default = { detail: exports.detail };
